<template>
    <div class="dark-blue hero">
    
      <v-container class="px-10 mt-lg-10 mt-xs-6 mt-sm-8 mt-md-8 pt-12 d-flex align-center justify-center fill-height" fluid>
        <v-row cols="12">
            <v-col cols="2"></v-col>
            <v-col cols="12" md="5" class="d-flex justify-center flex-column">
                <h1 class="section__header-title white--text text-h2 font-weight-bold">Campaigns</h1>
                <h2 class="white--text text-h5 font-italic mb-5">Deliver the right message, on the right channel, at the right time, to the right people.</h2>
                <h2 class="white--text text-subtitle-1">Reach your audience instantly with SMS, MMS, Voice, and Email campaigns that start conversations - not just send broadcasts.</h2>
            </v-col>
            <v-col cols="12" md="5">
                <div class="d-flex align-center flex-column steps">
                    <v-card class="step">
                        <v-card-title class="justify-center"><v-icon color="black" class="mr-2">mdi-account-group</v-icon> Choose your audience</v-card-title>
                    </v-card>
                    <div class="line"></div>
                    <v-card class="step">
                        <v-card-title class="justify-center"><v-icon color="black" class="mr-2">mdi-chat</v-icon> Customise your message
                            
                        </v-card-title>
                    </v-card>
                    <div class="line"></div>
                    <v-card class="step">
                        <v-card-title class="justify-center"><v-icon color="black" class="mr-2">mdi-send-clock</v-icon> Configure distribution</v-card-title>
                    </v-card>
                </div>
            </v-col>
            
        </v-row>
        
      </v-container>
    </div>
  </template>
  
<script>
    export default {
    name: 'CampaignsHero',
    }
</script>

<style lang="scss">



.line {
    height: 100px;
    width: 5px;
    background-color: white;
}

@keyframes emphasise {
	0% {

        transform: scale(1.0);
	}
    25% {

        transform: scale(1.08);
	}
    50% {

        transform: scale(1.0);
    }
}

$steps: 5;
$duration: 5s;

.step {

    width: 50%;
    animation: emphasise $duration ease-in-out infinite;

    @for $i from 1 through $steps {
        &:nth-child(#{$i}) {
            animation-delay: ($i - 1) * $duration * 0.2;
        }
    }
}


</style>
  